import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import ScrollView from "@/baseComponents/ScrollView";
import Weather from "./moduleComponents/weather";
import Banner from "./moduleComponents/banners";
import Enterprises from "./moduleComponents/Enterprises";
import FeedTab from "./moduleComponents/FeedTab";
import Grows from "./moduleComponents/Grows";
import Cards from "./moduleComponents/Cards";
import "./index.less";
import Service from "./moduleComponents/Service";
import { LAYOUT_MODULE_MAP } from "./config";
import { getLayoutList } from "@/api/home";
import Header from "./moduleComponents/Header";
import Bus from "@/utils/bus";
import { throttle } from "lodash";
import { useTranslation } from "react-i18next";
import { homeKey, homePartitionKey } from "../..";
import AIAssistant from "./AIAssistant";
import { isFocusEnv } from "@/utils";

export interface Iprops {
  onAppOrLinkClick: Function;
  t: any;
}
const onAppOrLinkClick = (item: any) => {
  console.log("onAppOrLinkClick", item);
  Bus.emit("openHomeApp", item);
};

function IndexPage() {
  const [layoutList, setLayoutList] = useState<any[]>([]);
  const [key, setKey] = useState(1);
  const [isScroll, setIsScroll] = useState(false);

  const { t } = useTranslation("common");
  const scrollViewRef: any = useRef();
  const fetchLayoutList = async () => {
    try {
      const res: any = await getLayoutList();
      // 过滤掉不需要展示的模块，header和banner模块单独渲染
      const list = res?.layoutList
        ?.filter(
          (item: any) => item.display === 1 && item.module !== "100000" && item.module !== "100001"
        )
        .map((item: any) => {
          const Component = LAYOUT_MODULE_MAP[item.module];
          return {
            ...item,
            content: <Component onAppOrLinkClick={onAppOrLinkClick} t={t} />
          };
        });

      console.log("getLayoutList", list);
      setLayoutList(list);
    } catch (error) {
      console.log("getLayoutList", error);
    }
  };
  const refreshWorkbench = (config: any) => {
    if (homePartitionKey !== config?.partition) return;
    setKey((pre) => {
      return pre + 1;
    });
    console.log("refreshWorkbench");
    fetchLayoutList();
  };
  useEffect(() => {
    Bus.on(`workbenchRefreshCb`, refreshWorkbench);
    return () => {
      Bus.off(`workbenchRefreshCb`, refreshWorkbench);
    };
  }, []);
  //   useEffect(() => {
  //     // @ts-ignore
  //     const font = new FontFace(
  //       "JDLangZhengTi",
  //       "url('https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/app_jqt/jingdonglangzhengti2-Semibold.ttf')"
  //     );
  //     // @ts-ignore
  //     document.fonts.add(font);
  //     // @ts-ignore
  //     font
  //       .load()
  //       .then(() => {
  //         console.log("iconloaded");
  //       })
  //       .catch((e: any) => {
  //         console.log("iconloaded error", e);
  //       });
  //   }, []);
  const onScroll = (e: any) => {
    const cu: any = e.target;
    const scrollTop = cu.scrollTop;
    const cHight = cu.clientHeight;
    const sHight = cu.scrollHeight;
    if (scrollTop > 0) {
      setIsScroll(true);
    } else {
      setIsScroll(false);
    }

    if (cu && scrollTop + cHight >= sHight - 10) {
      console.log("home-scrollToBottom");
      Bus.emit("home-scrollToBottom");
    }
  };
  useEffect(() => {
    fetchLayoutList();
  }, []);
  //   return null;

  return (
    <div className="home-page" id="home-page" key={key}>
      <div className={`${isScroll ? "scrolledHeader" : ""} fixed-header`}>
        <div className="fixed-header-content">
          <Header onAppOrLinkClick={onAppOrLinkClick} t={t} />
        </div>
      </div>
      <ScrollView
        className="scroll-view-index"
        autoHide
        // ref={scrollViewRef}
        onScroll={throttle(onScroll, 400)}
      >
        <div className="scroll-view-container">
          <Banner onAppOrLinkClick={onAppOrLinkClick} t={t} />
          {layoutList.map((item) => item.content)}
          {/* <div className="content">{layoutList.map((item) => item.content)}</div> */}
          {isFocusEnv() && <AIAssistant />}
        </div>
      </ScrollView>
    </div>
  );
}

export default IndexPage;
